export default {
  nav: {
    home: "Home",
    spreadsheet: "Spreadsheet",
    categories: "Categories",
    guides: "Guides",
    comparisons: "Comparisons",
    safety: "Safety",
    faq: "FAQ",
    search: "Search",
    language: "Language",
    cta: "Explore Spreadsheet",
  },
  categories: {
    shoes: "Shoes",
    hoodies: "Hoodies / Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants / Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear / Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },
  hero: {
    eyebrow: "THE ALLCHINABUY RESEARCH HUB",
    h1: "AllChinaBuy Spreadsheet — Find Products, Sellers & Buying Resources Faster",
    subheadline: "Explore the AllChinaBuy spreadsheet, product research guides, seller resources, QC tips, shipping information, warehouse guides and the latest buying resources — all organized in one place.",
    ctaPrimary: "Explore AllChinaBuy Spreadsheet",
    ctaSecondary: "Browse Buying Guides",
    trust: "Updated resources • Product research • QC guides • Shipping information • Safety resources",
    searchPlaceholder: "Search products, sellers, shipping guides or AllChinaBuy resources...",
  },
  valueProp: {
    h2: "Everything You Need to Research AllChinaBuy Products",
    copy: "Finding products is only the first step. Our AllChinaBuy resource hub helps you research products, compare options, understand QC information, explore shipping methods and make better-informed buying decisions.",
    cta: "Explore All Resources",
    cards: {
      spreadsheet: {
        title: "AllChinaBuy Spreadsheet",
        desc: "Find organized product and research resources.",
      },
      research: {
        title: "Product Research",
        desc: "Learn how to evaluate products before ordering.",
      },
      sellers: {
        title: "Seller Guides",
        desc: "Understand seller information and product selection.",
      },
      qc: {
        title: "QC Resources",
        desc: "Learn what to look for when reviewing quality-control information.",
      },
      shipping: {
        title: "Shipping Guides",
        desc: "Understand shipping options, costs and important considerations.",
      },
      safety: {
        title: "Safety Center",
        desc: "Learn practical ways to reduce common buying and security risks.",
      },
    },
  },
  spreadsheetPreview: {
    h2: "AllChinaBuy Spreadsheet",
    copy: "The AllChinaBuy Spreadsheet is the central resource for discovering products, organizing research and finding useful buying information. Use it as a starting point, then explore our detailed guides before making purchasing decisions.",
    cta: "Open AllChinaBuy Spreadsheet",
    columns: {
      product: "Product",
      category: "Category",
      seller: "Seller",
      status: "Research Status",
      qc: "QC Resource",
      guide: "Guide",
      updated: "Updated",
    },
  },
  trust: {
    h2: "Why Use This AllChinaBuy Resource Hub?",
    cards: {
      organized: {
        title: "Organized Research",
        desc: "Resources are grouped by product, category, seller, QC, shipping and buying intent.",
      },
      comparisons: {
        title: "Useful Comparisons",
        desc: "Clear tables help users understand differences between options.",
      },
      updated: {
        title: "Updated Content",
        desc: "Show publication and update dates.",
      },
      safetyFirst: {
        title: "Safety First",
        desc: "Provide practical information about product research, payments, accounts and shipping.",
      },
      multilingual: {
        title: "Multilingual",
        desc: "English, French, Danish and German versions.",
      },
      independent: {
        title: "Independent Resource",
        desc: "Clearly disclose the site's relationship with the main website where applicable.",
      },
    },
  },
  comparison: {
    h2: "AllChinaBuy Resources at a Glance",
    cta: "Explore the Full Resource Center",
    headers: {
      resource: "Resource",
      bestFor: "Best For",
      info: "Information",
    },
    rows: {
      spreadsheet: { name: "AllChinaBuy Spreadsheet", bestFor: "Product discovery", info: "Products & research" },
      productGuides: { name: "Product Guides", bestFor: "Product research", info: "Buying considerations" },
      qcGuides: { name: "QC Guides", bestFor: "Quality checking", info: "QC principles" },
      shippingGuides: { name: "Shipping Guides", bestFor: "Shipping research", info: "Methods & factors" },
      warehouseGuide: { name: "Warehouse Guide", bestFor: "Warehouse information", info: "Storage & processing" },
      safetyGuide: { name: "Safety Guide", bestFor: "Risk awareness", info: "Security & safety" },
    },
  },
  reviewSection: {
    h2: "AllChinaBuy Review: What Should Buyers Know?",
    copy: "Before using any buying platform, it is important to understand how product research, ordering, QC, warehouse processing and shipping work. Our AllChinaBuy review content focuses on practical information rather than unsupported claims.",
    cta: "Read the AllChinaBuy Review",
  },
  shippingSection: {
    h2: "AllChinaBuy Shipping Cost & Shipping Guide",
    copy: "Shipping costs can vary depending on destination, parcel size, weight, shipping method and other factors. Learn how shipping works, what can affect the final cost and how to compare available options.",
    cta: "View AllChinaBuy Shipping Guide",
  },
  couponSection: {
    h2: "AllChinaBuy Coupon & Discount Code",
    copy: "Looking for AllChinaBuy coupons or discount codes? Check our latest coupon and promotion resources before ordering. Always verify whether an offer is current, valid and subject to specific conditions.",
    cta: "Check Coupons & Discounts",
  },
  warehouseSection: {
    h2: "AllChinaBuy Warehouse Guide",
    copy: "Understand how warehouse storage, product inspection, processing and shipping preparation fit into the buying process.",
    cta: "Explore Warehouse Guide",
  },
  safetySection: {
    h2: "Is AllChinaBuy Legit & Safe?",
    copy: "Researching whether a platform is legitimate should involve more than a simple yes-or-no answer. Learn what to check, how to protect your account and payment information, how to evaluate product information and what risks to consider before ordering.",
    cta: "Read the AllChinaBuy Safety Guide",
  },
  finalCta: {
    h2: "Start With the AllChinaBuy Spreadsheet",
    copy: "Research products. Compare options. Understand QC and shipping. Make better-informed buying decisions.",
    ctaPrimary: "Explore AllChinaBuy Spreadsheet",
    ctaSecondary: "Read the Beginner Guide",
  },
  categoryButtons: {
    h2: "Browse AllChinaBuy Categories",
    copy: "Jump directly to your favorite product category on the main store.",
  },
  productShowcase: {
    h2: "Featured Products",
    copy: "Browse curated products from the AllChinaBuy Spreadsheet. Click any item to view details and purchase on the main store.",
    viewAll: "View All {{category}}",
  },
  productCard: {
    buyNow: "Buy Now",
  },
  productDetail: {
    notFound: "Product Not Found",
    notFoundDesc: "The product you are looking for does not exist or has been removed.",
    backHome: "Back to Home",
    verified: "Verified Product Listing",
    qcAvailable: "QC Photos Available",
    shippingGlobal: "Global Shipping Options",
    buyNow: "Buy Now — Go to Store",
    viewCategory: "View All in Category",
    redirectNotice: "You will be redirected to the official store to complete your purchase.",
    relatedTitle: "You May Also Like",
  },
  ctaButtons: {
    allchinabuy: "AllChinaBuy Spreadsheet",
    buyNow: "Buy It Now",
  },
  footer: {
    tagline: "AllChinaBuy Spreadsheet — Your research hub for smarter buying decisions.",
    links: {
      about: "About",
      privacy: "Privacy",
      terms: "Terms",
      contact: "Contact",
    },
    copyright: "© 2026 AllChinaBuy Spreadsheet. All rights reserved.",
  },
  lang: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
  article: {
    readMore: "Read Full Guide",
    relatedArticles: "Related Articles",
  },
  faq: {
    h2: "Frequently Asked Questions",
    q1: "What is the AllChinaBuy Spreadsheet?",
    a1: "The AllChinaBuy Spreadsheet is an organized resource that helps buyers discover products, research sellers, compare options and make informed purchasing decisions.",
    q2: "How do I use the AllChinaBuy Spreadsheet?",
    a2: "Start by browsing the categories that match your interest. Use the search function to find specific products or sellers. Review the QC and shipping guides before placing orders.",
    q3: "Is AllChinaBuy safe to use?",
    a3: "Safety depends on your research practices. Our guides cover account protection, payment security, product evaluation and risk-reduction strategies.",
    q4: "How much does AllChinaBuy shipping cost?",
    a4: "Shipping costs vary by destination, parcel weight, dimensions and chosen shipping method. Refer to our shipping guide for detailed breakdowns.",
    q5: "Does AllChinaBuy offer coupons or discounts?",
    a5: "Coupons and promotions may be available periodically. Always verify current offers and read the terms before applying any discount code.",
  },
};